import React from "react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { BalanceSelectOrderType } from "../../supplierAcquiringReportsTypes"
import { iterateStringEnum } from "../../../../../../lib/enums"

export function SelectOrderTypeFilter({
    orderPeriod,
    setOrderPeriod,
}: {
    orderPeriod: BalanceSelectOrderType
    setOrderPeriod: (period: BalanceSelectOrderType) => void
}) {
    return (
        <FormControl sx={{ minWidth: "13rem" }}>
            <LocalizedStrict id="supplier-overview-balance-details-dialog-select-order">
                <InputLabel id="supplier-overview-balance-details-dialog-select">Filter on</InputLabel>
            </LocalizedStrict>
            <LocalizedStrict id="supplier-overview-balance-details-dialog-select-order-label" attrs={{ label: true }}>
                <Select
                    labelId="supplier-overview-balance-details-dialog-select"
                    id="supplier-overview-balance-details-dialog-select-on"
                    value={orderPeriod}
                    label="Filter on"
                    onChange={(e) => setOrderPeriod(e.target.value as BalanceSelectOrderType)}
                >
                    {[...iterateStringEnum(BalanceSelectOrderType)].map((value) => (
                        <MenuItem key={value} value={value}>
                            <LocalizedEnum
                                base="supplier-overview-balance-details-dialog-select-order-mode"
                                enumValue={value}
                            >
                                <span>{value}</span>
                            </LocalizedEnum>
                        </MenuItem>
                    ))}
                </Select>
            </LocalizedStrict>
        </FormControl>
    )
}
